import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {API_BASE_URL} from "../config";
import {generateStrongPassword} from "../utils/passwordUtils";

const Register = () => {
    const [user, setUser] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('')
    const [registerMessage, setRegisterMessage] = useState('');
    const roles = ['Administrateur', 'Editeur', 'Consultant'];
    const [password, setPassword] = useState('');

    useEffect(() => {
        document.title = 'Enregistrer un utilisateur'
    }, []);

    const handleRegister = (e) => {
        e.preventDefault();

        axios.post(`${API_BASE_URL}/register`, { user, email, password, role })
            .then(response => {
                if (response.data.status === 'ok') {
                    // Successful login
                    // Perform actions such as setting user session, redirecting, etc.
                    setRegisterMessage('Utilisateur enregistré avec succès');

                } else {
                    // Wrong credentials
                    setRegisterMessage('Une erreur est survenue.');
                }
            })
            .catch(error => {
                // Handle network errors
                console.error('Error:', error);
                setRegisterMessage('An error occurred. Please try again later.');
            });
    };

    return (
        <div>
            <div className="register-container">
                <form className="register-form" onSubmit={handleRegister}>
                    <h2 className="title">Création d'un utilisateur</h2>
                    <div className="input-container">
                        <div className="input-icon">
                            <i className="fas fa-user icon"></i>
                        </div>
                        <input className="input" type="text" placeholder="Prénom et nom" required
                               autoFocus={true}
                               value={user} onChange={(e) => setUser(e.target.value)}/>
                    </div>
                    <div className="input-container">
                        <div className="input-icon">
                            <i className="fas fa-envelope icon"></i>
                        </div>
                        <input className="input" type="email" placeholder="Email" required
                               value={email} onChange={(e) => setEmail(e.target.value)}/>
                    </div>
                    <div className="input-container">
                        <div className="input-icon">
                            <i className="fas fa-lock icon"></i>
                        </div>
                        <input
                            className="input"
                            type="text"
                            placeholder="Mot de passe"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <span className="btn-generate" onClick={()=>setPassword( generateStrongPassword)}><i
                            className="fa-solid fa-arrows-rotate"></i></span>
                    </div>
                    <div className="input-container custom-select">
                        <div className="input-icon">
                            <i className="fa-solid fa-user-lock icon"></i>
                        </div>
                        {/* Dropdown for roles */}
                        <select
                            className="input"
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            required
                        >
                            <option value="" disabled hidden>Choisir un rôle</option>
                            {roles.map((roleOption) => (
                                <option key={roleOption} value={roleOption}>{roleOption}</option>
                            ))}
                        </select>
                    </div>
                    {/* Display login error message */}
                    {registerMessage && <p className="error-message">{registerMessage}</p>}
                    <button className="btn-login" type="submit">Enregistrer un utilisateur</button>

                </form>
            </div>
        </div>
    );
};

export default Register;
